import React from 'react';
import { useAppSelector } from '../../../../app/hooks';
import { Spinner } from '../../../spinner/Spinner';

import { ReScanButton } from '../../buttons/ReScanButton';
import { selectCodeScanStatus } from '../../dashboardSlice';
import { CodeScanStatus } from '../../types';

import styles from './Placeholder.module.scss';

export const CodeSecurityPlaceholder: React.FC = () => {
  const codeScanStatus = useAppSelector(selectCodeScanStatus);

  const renderSpinner = () => (
    <div className={styles.PlaceholderContainer}>
      <Spinner />

      <p>
        Code scan is in progress. This may take more time to complete depending upon the amount of code in your org.
        We will send you the report after the scan completes.
      </p>
    </div>
  );

  const renderPlaceholder = () => (
    <div className={styles.PlaceholderContainer}>
      <ReScanButton />

      <p>
        Click Re-scan your org button.
        It will scan the code present in your org using the FlosumScan tool.
        This tool will scan the code against a subset of rules.
        To scan the entire code present in your org/Git repositories using FlosumScan, please contact Flosum Support.
      </p>
    </div>
  );

  if (codeScanStatus === CodeScanStatus.Started) {
    return renderSpinner();
  } else {
    return renderPlaceholder();
  }
}
